<template>
  <div>
    <Fontnavbar title="编辑地址" />
    <div>
      <div style="text-align:center;">智能地址填写</div>
      <div style="text-align:center;">
        <span>粘贴整段地址，自动识别姓名、电话和地址</span>
      </div>
      <div
        class="layui-input-block"
        style="width: 100%"
      >
        <textarea
          class="add_textarea"
          placeholder="例如：张三，13200000000，广东省深圳市南山区某某街道某某大厦001号"
          maxlength="100"
          style="width:80%;height:150px;margin-left:8.5%"
          v-model="text"
        ></textarea>
        <span
          id="textarea_num"
          style="position:absolute; right:0px; bottom:4px;font-size:12px; color:#BDCADA"
        ><i>0</i>/100</span>
      </div>
      <div
        class="text-center"
        style="padding-left:35%"
      >
        <button
          id="recognition"
          type="button"
          @click="look"
        >智能识别
        </button>
      </div>
    </div>
    <van-address-edit
      :area-list="areaList"
      :show-delete="showDelete"
      show-set-default
      :address-info="address"
      :area-columns-placeholder="['请选择', '请选择', '请选择']"
      @save="onSave"
      @delete="onDelete"
    />
  </div>
</template>

<script>
import { getAddress, updateAddress, deleteAddress } from '../../../api.js'
import { post } from '../../../request.js'
import { AddressEdit, Toast } from 'vant'
import areaList from '../../../utils/area.js'
import Fontnavbar from '../../../components/Navbar.vue'
import AddressParse from 'address-parse'
export default {
  components: {
    [AddressEdit.name]: AddressEdit,
    Fontnavbar,
  },
  data() {
    return {
      text: '',
      areaList,
      addressId: 0,
      showDelete: false,
      address: {
        id: 0,
        name: '',
        tel: '',
        province: '',
        city: '',
        county: '',
        addressDetail: '',
        areaCode: '',
        isDefault: false,
        text: '',
      },
    }
  },
  mounted() {
    const that = this
    if (that.$route.query.address_id) {
      that.showDelete = true
      that.addressId = that.$route.query.address_id
      post(getAddress, { address_id: that.addressId }).then((res) => {
        if (res.code == 200) {
          that.address.id = res.data[0].id
          that.address.name = res.data[0].user_name
          that.address.tel = res.data[0].user_phone
          that.address.province = res.data[0].province
          that.address.city = res.data[0].city
          that.address.county = res.data[0].district
          that.address.addressDetail = res.data[0].address
          that.address.isDefault = res.data[0].is_default == 1 ? true : false
          var district = that.areaList.county_list
          var city_list = that.areaList.city_list

          for (var key in district) {
            if (res.data[0].district == district[key]&&res.data[0].city == city_list[parseInt(key / 100) * 100]) {
                that.address.areaCode = key
            }
          }
        } else if (res.code == 201) {
          this.$router.push({ path: '/user/login' })
        }
      })
    }
  },

  methods: {
    onSave(detail) {
      var that = this
      var address = {
        id: detail.id,
        user_name: detail.name,
        user_phone: detail.tel,
        province: detail.province,
        city: detail.city,
        district: detail.county,
        address: detail.addressDetail,
        is_default: detail.isDefault ? 1 : 0,
      }
      post(updateAddress, address).then((res) => {
        if (res.code == 200) {
          Toast.success(res.msg)
          setTimeout(function () {
            that.$router.go(-1)
          }, 1500)
        } else if (res.code == 201) {
          this.$router.push({ path: '/user/login' })
        } else {
          Toast(res.msg)
        }
      })
    },
    onDelete(detail) {
      var that = this
      post(deleteAddress, { id: detail.id }).then((res) => {
        if (res.code == 200) {
          Toast.success(res.msg)
          var address = {}
          that.$store.dispatch('setUserAddress', address)
          setTimeout(function () {
            that.$router.go(-1)
          }, 1500)
        } else if (res.code == 201) {
          this.$router.push({ path: '/user/login' })
        } else {
          Toast(res.msg)
        }
      })
    },
    //智能识别
    look() {
      console.log(this.text)
      //智能识别
      var add_textarea = this.text
      if (add_textarea == '') {
        return
      }
      var results = AddressParse.parse(add_textarea)
      console.log(results)
      var resultss = results[0]
      console.log(resultss)
      if (resultss.name != '') {
        this.address.name = resultss.name
        // console.log(this.address.user_name)
      }
      var phoneReg = /^1\d{10}$/

      if (resultss.mobile != '' && phoneReg.test(resultss.mobile)) {
        this.address.tel = resultss.mobile
      }
      if (resultss.details != '') {
        this.address.addressDetail = resultss.details
      }
      // let city_data = {};
      if (resultss.province != '') {
        this.address.province = resultss.province
        console.log(this.address.province)
      }

      if (resultss.city != '') {
        this.address.city = resultss.city
      }
      var that = this
      if (resultss.area != '') {
        var district = that.areaList.county_list
        var city_list = that.areaList.city_list
        for (var key in district) {
          if (resultss.area == district[key]&&resultss.city == city_list[parseInt(key / 100) * 100]) {
            that.address.areaCode = key
            break
          }
        }
        this.address.county = resultss.area
      }
    },
    onSelect(item) {
      // var chosenAddressId = item.id
      var that = this
      var address = {
        id: item.id,
        user_name: item.name,
        user_phone: item.tel,
        address: item.address,
      }
      that.$store.dispatch('setUserAddress', address)
      setTimeout(function () {
        that.$router.go(-1)
      }, 300)
    },
  },
}
</script>

<style lang="less" scoped>
.login-btn {
  margin: 15px;
}
.login-tip {
  margin: 15px 15px 0;
  font-size: 14px;
  color: #f00;
  text-align: right;
}
.login-tip span {
  margin: 0px 5px;
}
</style>
